import React, { useEffect } from 'react'
import TechnicalExpertiseMainBlock from '../../components/TechnicalExpertiseMainBlock/TechnicalExpertiseMainBlock'
import TechnicalExpertisePreviewBlock from '../../components/TechnicalExpertisePreviewBlock/TechnicalExpertisePreviewBlock'
import WhyDMPImportant from '../../components/WhyDMPImportant/WhyDMPImportant'
import DiagramTabs from '../../components/DiagramTabs/DiagramTabs'
import ContactUs from '../../components/ContactUs/ContactUs'
import mainDiagramUI from './../../components/TechnicalExpertiseMainBlock/Frame 16.png'

import designForDark from './../../components/WhyDMPImportant/designUIPink.svg'
import designForLight from './../../components/WhyDMPImportant/designUIBlue.svg'
import usabilityForDark from './../../components/WhyDMPImportant/usabilityUIPink.svg'
import usabilityForLight from './../../components/WhyDMPImportant/usabilityUIBlue.svg'
import supportForDark from './../../components/WhyDMPImportant/supportUIPink.svg'
import supportForLight from './../../components/WhyDMPImportant/supportUIBlue.svg'

import designDiagram from './../../components/DiagramTabs/designUIDiagram.png'
import componentDiagram from './../../components/DiagramTabs/componentDiagram.png'
import usabilityDiagram from './../../components/DiagramTabs/usabilityDiagram.png'
import prototypeDiagram from './../../components/DiagramTabs/prototypeDiagram.png'
import maintenanceDiagram from './../../components/DiagramTabs/maintenanceDiagram.png'

export default function TechnicalExpertiseUIDevelopment() {

  const uiDevelopmentContent = {
    technicalExpertisePrivewBlock: {
      firstTitle: 'UI development',
      secondTitle: 'Consultancy Services',
      bottomText: 'Elevate your digital presence with our team of expert UI developers, dedicated to creating seamless and visually compelling user experiences that bring your design vision to life'
    },
    technicalExpertiseMainBlock: {
      title: 'We empower clients with impactful UI designs, enhancing user engagement and delivering exceptional value through compelling digital experiences',
      imageSource: mainDiagramUI
    },
    whyImportant: {
      mainTitle: 'UI development',
      imgSrc1Dark: designForDark,
      imgSrc1Light: designForLight,
      title1: 'Advanced Design and Visualization',
      desc1: 'A User Interface (UI) development partner is important because it ensures the development of sophisticated design and visualization, creating interfaces that are not only aesthetic, but also effective in communicating information and interacting with users',
      imgSrc2Dark: usabilityForDark,
      imgSrc2Light: usabilityForLight,
      title2: 'Usability and Accessibility',
      desc2: 'The UI development partner plays a critical role in testing and ensuring the usability of the interfaces being created, as well as their accessibility to a wide range of users, including people with disabilities',
      imgSrc3Dark: supportForDark,
      imgSrc3Light: supportForLight,
      title3: 'Application Support and Updating',
      desc3: 'The UI Development Partnership ensures continuous support and updating of applications, ensuring their stable operation, as well as the introduction of new functionality and design solutions in accordance with market requirements and user feedback',
    },
    diagramTabs: {
      data: [
        {
          label: "UI Architecture Design",
          value: "design",
          imageSource: designDiagram,
          desc: `This involves the strategic planning and conceptualization of the overall structure and organization of a user interface, ensuring its coherence with the project's goals and requirements.`,
        },
        {
          label: "UI Component Development",
          value: "component",
          imageSource: componentDiagram,
          desc: `It focuses on creating individual elements that collectively form the user interface, encompassing the design and implementation of specific features, functionalities, and visual elements.`,
        },

        {
          label: "Usability Testing",
          value: "usability",
          imageSource: usabilityDiagram,
          desc: `This crucial step involves evaluating the effectiveness of the user interface through real-world scenarios, identifying potential issues, and gathering user feedback to ensure optimal user experience.`,
        },

        {
          label: "Prototype Development",
          value: "prototype",
          imageSource: prototypeDiagram,
          desc: `Creating functional prototypes that serve as early representations of the UI design, allowing stakeholders to visualize and interact with the proposed interface before final implementation.`,
        },

        {
          label: "UI Application Maintenance",
          value: "maintenance",
          imageSource: maintenanceDiagram,
          desc: `Ongoing efforts to address bugs, implement updates, and optimize performance based on user feedback, ensuring a seamless and reliable user experience throughout the application's lifecycle.`,
        },
      ]
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <div>
      <TechnicalExpertisePreviewBlock technicalExpertisePrivewBlock={uiDevelopmentContent.technicalExpertisePrivewBlock} />
      <TechnicalExpertiseMainBlock technicalExpertiseMainBlock={uiDevelopmentContent.technicalExpertiseMainBlock} />
      <WhyDMPImportant whyImportant={uiDevelopmentContent.whyImportant} />
      <DiagramTabs diagramTabs={uiDevelopmentContent.diagramTabs} />
      <ContactUs />
    </div>
  )
}